module.exports = "<p>cdcbdcbdjc</p>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app_manager/app_element/communication/communication.component.html
// module id = ./src/app/app_manager/app_element/communication/communication.component.html
// module chunks = main